import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { useState, useEffect } from 'react';
import style from "./Banner.module.css";
import { NavLink } from 'react-router-dom';

const Banner = () => {

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 720);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 720);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return(
        <div className={style.banner}>
            <Carousel showThumbs={false} showStatus={false} infiniteLoop={true} autoPlay={true} interval={5000} transitionTime={1000} swipeable={!isMobile}>

                    <div className={style.banner1}>
                        {isMobile ? (
                            <>
                                <div className={style.banner1text}>                                    
                                    <h3>Monoambiente</h3>
                                    <p className={style.price}>Premium</p>
                                    <p className={style.text}>18m2 Línea Wood Frame</p>
                                    <p className={style.textBigger}><span className={style.textPrice}>$7.269.000</span></p>                                    
                                    <p className={style.text}>Flete y armado bonificados hasta 100km</p>
                                    {/* <p className={style.textBigger}>Ahora <span className={style.textPrice}>$5.030.000</span></p>*/}
                                    <p className={style.number}>
                                        <img src="https://schiabudini.github.io/viviendasPlatenseImg/resources/banners/1/whatsapp.svg" alt=""/>
                                        <a href='https://wa.me/542216911442?text=Buenos%20d%C3%ADas,%20quisiera%20consultar%20por%20el%20modelo%20en%20promoci%C3%B3n.%20Muchas%20gracias.'>Envianos un WhatsApp </a>
                                        
                                    </p>
                                    {/*
                                    <h3>CONSULTAR PROMOS</h3>
                                    
                                    <p className={style.text}>Platea de hormigón de regalo</p>
                                    <p className={style.text}>En todas nuestras líneas</p>
                                    <p className={style.number}>
                                        <img src="https://schiabudini.github.io/viviendasPlatenseImg/resources/banners/1/whatsapp.svg" alt=""/>
                                        <a href='https://wa.me/542216911442?text=Buenos%20d%C3%ADas,%20quisiera%20consultar%20por%20el%20modelo%20en%20promoci%C3%B3n.%20Muchas%20gracias.'>Envianos un WhatsApp </a>
                                        
                                    </p> */}
                                </div>
                                <div className={style.banner1render}><img  src="https://schiabudini.github.io/viviendasPlatenseImg/resources/banners/1/banner_1_img_3_2.jpeg" alt="22,5 Americana - 1 Dormitorio - En promoción"/></div>
                            </>
                        ) : (
                            <>
                                <div className={style.banner1bg}><img src="https://schiabudini.github.io/viviendasPlatenseImg/resources/banners/1/banner_1_bg.svg" alt=""/></div>
                                <div className={style.banner1render}><img  src="https://schiabudini.github.io/viviendasPlatenseImg/resources/banners/1/banner_1_img_3_2.jpeg" alt="22,5 Americana - 1 Dormitorio - En promoción"/></div>
                                <div className={style.banner1logo}><img src="https://schiabudini.github.io/viviendasPlatenseImg/resources/logo.svg" alt=""/></div>
                                <div className={style.banner1text}>
                                    <h3>Monoambiente</h3>
                                    <p className={style.price}>Premium</p>
                                    <p className={style.text}>18m2 Línea Wood Frame</p>
                                    <p className={style.textBigger}><span className={style.textPrice}>$7.269.000</span></p>
                                    <p className={style.text}>Flete y armado bonificados hasta 100km</p>
                                    {/* <p className={style.textBigger}>Ahora <span className={style.textPrice}>$5.030.000</span></p>*/}
                                    <p className={style.number}>
                                        <img src="https://schiabudini.github.io/viviendasPlatenseImg/resources/banners/1/whatsapp.svg" alt=""/>
                                        <a href='https://wa.me/542216911442?text=Buenos%20d%C3%ADas,%20quisiera%20consultar%20por%20el%20modelo%20en%20promoci%C3%B3n.%20Muchas%20gracias.'>Envianos un WhatsApp </a>
                                        
                                    </p>
                                     
                                    {/* <h3>CONSULTAR PROMOS</h3>
                                    <p className={style.text}>Platea de hormigón de regalo</p>
                                    <p className={style.text}>En todas nuestras líneas</p>
                                    <p className={style.number}>
                                        <img src="https://schiabudini.github.io/viviendasPlatenseImg/resources/banners/1/whatsapp.svg" alt=""/>
                                        <a href='https://wa.me/542216911442?text=Buenos%20d%C3%ADas,%20quisiera%20consultar%20por%20el%20modelo%20en%20promoci%C3%B3n.%20Muchas%20gracias.'>Envianos un WhatsApp </a>
                                        
                                    </p>*/}
                                </div>
                            </>
                        )}
                    </div>

                    <div className={style.banner2}>
                        <div className={style.banner2bg}><img src="https://schiabudini.github.io/viviendasPlatenseImg/resources/banners/2/banner_2%20_bg.svg" alt=""/></div>
                        
                        {isMobile ? (
                            <div className={style.content}>
                                <div className={style.contentText}>
                                    <p className={style.textBlue}>Con la compra de tu casa<br/>colaborás con <a href="https://www.instagram.com/rescataditoslaplata/" target="_blank" rel="noopener noreferrer">Rescataditos La Plata</a></p>
                                    <div className={style.textBottom}>
                                        <p><span className={style.textRed}>Adoptá, no compres</span><br/>Tu hogar es mejor con una mascota</p>
                                        <p className={style.contentLogo}>
                                            <img src="https://schiabudini.github.io/viviendasPlatenseImg/resources/banners/2/logo_rescataditos_borde-05.png" alt="Rescataditos La Plata"/>
                                            <img src="https://schiabudini.github.io/viviendasPlatenseImg/resources/banners/2/logo_viviendas_borde-05.png" alt="Viviendas Platense"/>
                                        </p>
                                        
                                    </div>
                                </div>
                                <div className={style.contentImg}><img src="https://schiabudini.github.io/viviendasPlatenseImg/resources/banners/2/banner_2_img.png" alt="Equipos de Viviendas Platense y Rescataditos La Plata"/></div>
                            </div>
                        ) : (
                            <div className={style.content}>
                                <div className={style.contentImg}><img src="https://schiabudini.github.io/viviendasPlatenseImg/resources/banners/2/banner_2_img.png" alt="Equipos de Viviendas Platense y Rescataditos La Plata"/></div>
                                <div className={style.contentText}>
                                    <p className={style.textBlue}>Con la compra de tu casa<br/>colaborás con <a href="https://www.instagram.com/rescataditoslaplata/" target="_blank" rel="noopener noreferrer">Rescataditos La Plata</a></p>
                                    <div className={style.textBottom}>
                                        <p><span className={style.textRed}>Adoptá, no compres</span><br/>Tu hogar es mejor con una mascota</p>
                                        <p className={style.contentLogo}><img src="https://schiabudini.github.io/viviendasPlatenseImg/resources/banners/2/logo_rescataditos_borde-05.png" alt="Rescataditos La Plata"/></p>
                                        <p className={style.contentLogo}><img src="https://schiabudini.github.io/viviendasPlatenseImg/resources/banners/2/logo_viviendas_borde-05.png" alt="Viviendas Platense"/></p>
                                    </div>
                                </div>
                            </div>
                        )}
                        
                        <div className={style.vector}><img src="https://raw.githubusercontent.com/SChiabudini/viviendasPlatenseImg/f8dd4d0d7d94bd3c3bd80680d8a1a53f8dd52123/resources/banners/2/banner_2_vector.svg" alt=""/></div>
                    </div>

                    <div className={style.banner3}>
                        <NavLink to="/catalogo">
                            <div className={style.banner3bg}></div>
                            <div className={style.content}>
                                <h3>Viviendas Platense</h3>
                                <div className={style.images}>
                                    <div className={style.imageContainer}>
                                        <div className={style.imageOverlay}></div>
                                        <img src="https://schiabudini.github.io/viviendasPlatenseImg/catalogue/36%20Americana%20-%202%20Dormitorios/1-1.jpg" alt="Modelo Americano"/>
                                        <p>PREMIUM</p>
                                    </div>
                                    <div className={style.imageContainer}>
                                        <div className={style.imageOverlay}></div>
                                        <img src="https://schiabudini.github.io/viviendasPlatenseImg/resources/banners/3/eco.jpg" alt="Modelo Minimalista"/>
                                        <p>ECO</p>
                                    </div>
                                    <div className={style.imageContainer}>
                                        <div className={style.imageOverlay}></div>
                                        <img src="https://schiabudini.github.io/viviendasPlatenseImg/catalogue/58%2C5%20Steel%20-%203%20Dormitorios/1.jpg" alt="Modelo 2 Plantas"/>
                                        <p>STEEL</p>
                                    </div>
                                </div>
                            </div>
                        </NavLink>  
                    </div>
            </Carousel>
        </div>
    );
}

export default Banner;
